module.exports = __webpack_public_path__ + "static/media/double-chocolate-chunk.11070e29.png";